module.exports = __webpack_public_path__ + "static/media/productHeroImg.6f6db0bf.webp";